// src/shared/components/fields/TextField.tsx
import React, { forwardRef, useId } from "react";
import type { InputHTMLAttributes } from 'react'; 
import styles from "./Fields.module.scss";

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string; // Текст ошибки, если есть
}

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ label, error, className = "", id, ...props }, ref) => {
    // Генерируем уникальный ID, если он не передан, чтобы связать label и input
    const generatedId = useId();
    const fieldId = id || generatedId;

    return (
      <div className={`${styles.fieldContainer} ${className}`}>
        {label && (
          <label htmlFor={fieldId} className={styles.label}>
            {label}
          </label>
        )}

        <input
          ref={ref}
          id={fieldId}
          className={`${styles.input} ${error ? styles.hasError : ""}`}
          {...props}
        />

        {error && <span className={styles.errorMessage}>{error}</span>}
      </div>
    );
  }
);

TextField.displayName = "TextField";
